import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import update from 'immutability-helper';
import axios from 'axios';

import { safeStringify } from 'utils/Helpers';
import Validator from 'utils/Validator';

import App from 'contexts/App';
import { Container, Column } from 'components/Layouts/Flow';
import { Form, Input } from 'components/Form';
import Button from 'components/Button';

import { useLocalStorage } from 'react-haiku';
import Message from 'containers/Authentication/Message';

import { useAppStore } from 'store/useAppStore';

const Login = () => {
	// Use app's context
	// const { setAuthentication } = useContext(App);

	// Use app's store
	const [setAuthenticated, setUser, setValid] = useAppStore(state => [state.setAuthenticated, state.setUser, state.setValid]);

	// Use local storage
	const [, setStorageToken] = useLocalStorage('token');
	const [, setStorageUser] = useLocalStorage('user');

	// Store user's data
	const [data, setData] = useState({
		email: '',
		password: ''
	});

	// Store error's message
	const [error, setError] = useState('');

	// Store temporary message
	const [temporary, setTemporary] = useState('');

	// Store request progress state
	const [progress, setProgress] = useState(false);

	// Handles input's onChange event
	// @event: object | onChange event
	const onChange = event => {
		const { name, value } = event.target;

		// Unset error's message
		setError('');

		// Update field's value
		setData(d => update(d, {
			[name]: {
				$set: value
			}
		}));
	};

	// Handles form's onSubmit event
	// @event: object | onSubmit event
	const onSubmit = event => {
		event.preventDefault();

		// Validate user's data
		Validator.validate('/auth', data);

		// Update error's if there were any
		if (Validator.errors) return setError('Pārliecinaties, vai ievadītie dati ir korekti!');

		// Uodate progress state
		setProgress(true);

		// Creates authorization request
		axios({
			method: 'post',
			url: `${process.env.REACT_APP_API}/auth/login`,
			data: data
		}).then(res => {
			// Reset progress state
			setProgress(false);

			// Store user's token
			setStorageToken(res.data?.token);

			// Store user's date
			setStorageUser(res.data?.user);

			// Update system access
			setAuthenticated(true);
			setUser(res.data?.user);
			setValid(true);

		}).catch(err => {
			// Get errror response
			const message = err.response?.data.error;

			// Reset progress state
			setProgress(false);

			if (message === 'authorizationUnsuccessful' || message === 'validationFail') {
				// Set error message
				setError('Neatpazinām Jūsu autorizācijas datus, pārliecinaties, vai tie ir korekti!');
			} else if (message === 'studentTemporaryBlocked') {
				// Set error message
				setTemporary('Viss kārtībā! Mācību vide šobrīd tiek sagatavota jaunajam mācību gadam! Izbaudi vasaru un mācību procesu šogad sāksi 10. septembrī! 🥳');
			} else if (message === 'parentTemporaryBlocked') {
				// Set error message
				setTemporary('Viss kārtībā! Mācību vide šobrīd tiek sagatavota jaunajam mācību gadam! Mācību process sāksies septembrī! 🥳');
			} else {
				// Set error message
				setError('Hmm, kaut kas noticis ar serveri!');
			}
		});
	};

	return (
		<div className="authorization__login">
			<Form progress={progress} onSubmit={onSubmit}>
				<Container>
					<Column size="12">
						<h1>Pieslēgties</h1>
					</Column>

					<Column size="12">
						<Input
							type="email"
							name="email"
							placeholder="tavs@epasts.lv"
							label="E-pasts"
							icon="mail"
							value={data.email}
							onChange={onChange}
						/>
					</Column>

					<Column size="12">
						<Input
							type="password"
							name="password"
							label="Parole"
							icon="lock"
							value={data.password}
							onChange={onChange}
						/>
					</Column>

					{/* Will be rendered only on error */}
					<Message type="error" message={error} />

					{/* Will be rendered only on temporary */}
					<Message type="success" message={temporary} />

					<Column size="12" asFlexEnd>
						<Link to="/forgot">Aizmirsi paroli?</Link>
					</Column>

					<Column size="12">
						<Button submit block text="Pieslēgties" />
					</Column>
				</Container>
			</Form>
		</div>
	);
};

export default Login;
